export const LEGEND_COLORS = [
  "var(--primary-40)",
  "var(--success-20)",
  "var(--accent-secondary-20)",
  "var(--accent-tertiary-20)",
  "var(--danger-20)",
  "var(--caution-20)",
  "var(--accent-primary-60)",
  "var(--success-60)",
  "var(--accent-secondary-40)",
  "var(--accent-tertiary-40)",
  "var(--primary-80)",
  "var(--accent-primary-80)",
  "var(--accent-tertiary-80)",
  "var(--danger-80)",
];

export type NotarizeCountScalarHash = {
  label: string;
  count: number | null;
} & NotarizeScalarHash;

export type NotarizeMedianHash = {
  label: string;
  median: number | string | null;
} & NotarizeScalarHash;

export type NotarizeAverageHash = {
  label: string;
  average: number | string | null;
} & NotarizeScalarHash;

export type NotarizeSummaryScalarHash = NotarizeMedianHash | NotarizeAverageHash;

export type NotarizeSentCompletedScalarHash = {
  label: string;
  completed_count: number | null;
  sent_count: number | null;
};

export function isNotarizeSentCompletedScalarHashArray(
  arr: NotarizeScalarHash[],
): arr is NotarizeSentCompletedScalarHash[] {
  return arr.every(
    (item) =>
      typeof item.label === "string" &&
      (typeof item.completed_count === "number" || item.completed_count === null) &&
      (typeof item.sent_count === "number" || item.sent_count === null),
  );
}

export function isNotarizeCountScalarHashArray(
  arr: NotarizeScalarHash[],
): arr is NotarizeCountScalarHash[] {
  return arr.every(
    (item) =>
      typeof item.label === "string" && (typeof item.count === "number" || item.count === null),
  );
}

// Helper function to check if a value is a valid numeric value, numeric string, or null
function isValidNumericValueOrNull(value: unknown): value is number | string | null {
  if (value === null) {
    return true;
  }
  if (typeof value === "number") {
    return !isNaN(value) && isFinite(value);
  }
  if (typeof value === "string") {
    if (value.trim() === "") {
      return true;
    }
    const num = Number(value);
    return !isNaN(num) && isFinite(num);
  }
  return false;
}

export function isNotarizeSummaryScalarHashArray(
  arr: NotarizeScalarHash[],
): arr is NotarizeSummaryScalarHash[] {
  return arr.every(
    (item): item is NotarizeSummaryScalarHash =>
      typeof item.label === "string" &&
      (("median" in item && isValidNumericValueOrNull(item.median)) ||
        ("average" in item && isValidNumericValueOrNull(item.average))),
  );
}
